import Header from "./Header";
import Footer from "./Footer";
import { useLenis } from "../lib/useLenis";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Loader";
import { MessageCircle } from "lucide-react";
import { company } from "../data/site";

export default function Layout({ children }) {
  useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div className="min-h-screen bg-[#FAFAFA] grain relative">
      <Loader />
      <Header />
      <main className="min-h-[60vh]">{children}</main>
      <Footer />
      {/* Floating WhatsApp */}
      <a
        data-testid="floating-whatsapp"
        href={company.whatsapp}
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="fixed z-40 bottom-6 right-6 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_20px_40px_-10px_rgba(37,211,102,0.5)] hover:scale-110 transition-transform"
      >
        <MessageCircle size={22} />
      </a>
    </div>
  );
}
